import { DateInput } from '@/components/form/DateInput.tsx';
import { FilterFieldOperator } from '@/components/table/_filterFieldOperators/FilterFieldOperator.ts';
import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';

export const DateTimeFilterInputs = ({ form, index }: FilterInputProps) => {
  const operator = form.watch(`filters.${index}.operator`);

  return (
    <div className="flex gap-2">
      <DateInput
        inputSize="toolbar"
        control={form.control}
        dateFieldName={`filters.${index}.value`}
      />
      {operator === FilterFieldOperator.BETWEEN && (
        <DateInput
          inputSize="toolbar"
          control={form.control}
          dateFieldName={`filters.${index}.secondValue`}
        />
      )}
    </div>
  );
};
